"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCreateHtmlFromBasicBlock = exports.createHtmlFromHorizontalRule = void 0;
var createHtmlFromHorizontalRule = function () {
    return "<hr class=\"project-block__block-element\" />";
};
exports.createHtmlFromHorizontalRule = createHtmlFromHorizontalRule;
var tagFromType = function (type) {
    var tags = {
        paragraph: "p",
        heading1: "h1",
        heading2: "h2",
        blockQuote: "blockquote",
    };
    return tags[type];
};
var makeCreateHtmlFromBasicBlock = function (type) { return function (token, _a) {
    var innerHtml = _a.innerHtml;
    var tag = tagFromType(type);
    if (innerHtml === "" || /^<span[^>]*><\/span>$/.test(innerHtml)) {
        innerHtml = "<br />";
    }
    var tagClassName = "project-block__block-element";
    return "<".concat(tag, " class=\"").concat(tagClassName, "\">").concat(innerHtml, "</").concat(tag, ">");
}; };
exports.makeCreateHtmlFromBasicBlock = makeCreateHtmlFromBasicBlock;
